<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :searchParams="searchParams"
              :tableData="tableData"
              @add="add"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()">
      <div slot="table">
        <label-table :tableData="tableData.list" @update="update" @del="del"></label-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import LabelTable from "./coveShedAddressTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getCoveShedAddressList,newVue,delByCoveShedAddressId} from "../../network/coveShedAddress";

  export default {
    name: "LabelList",
    components: {LabelTable, MyTable},
    data(){
      return {
        title: "心坞栈区域列表",
        //搜索条件
        searchParams:[
          {
            key:"labelName",
            value:"标签名"
          },
        ],
        isAdd:true,
        tableData:{},
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo = {
        href: "/coveShedAddress/list",
        name: "心坞栈区域管理"
      };
      this.common.HeaderLocationTwo.href = "/coveShedAddress/list";
      this.common.HeaderLocationTwo.name = "心坞栈区域管理";
      this.common.HeaderLocationThree.name = "心坞栈区域列表"
      getCoveShedAddressList().then(res => {
        this.tableData = res.data
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let labelName = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "labelName") {
            labelName = searchItems[i].input
          }
        }
        getCoveShedAddressList(labelName,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      add(){
        this.$router.push("insert/")
      },
      update(id){
        this.$router.push("insert/"+id)
      },
      del(id){
        this.$confirm('此操作会将该标签永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delByCoveShedAddressId(id).then(res => {
              if (res.code == 200) {
                this.searchEasy(this.searchItems);
              }
            }
          )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  }
</script>

<style scoped>

</style>
